import { StripePaymentMethodType } from '../../../../type/model/stripe/stripe-payment-method.type';

export const cardToString = (card: StripePaymentMethodType) => `${ card.brand } ending with ${ card.last4 },
 Expires ${ card.exp_month }/${ card.exp_year }`;
